import React from 'react';

import { Icon, Typography } from '@telus-uds/components-web';
import Information from '@telus-uds/palette-allium/build/web/icons/Information';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { NoInfoContainer } from './css';

// eslint-disable-next-line react/prop-types
const NoInformationFound = ({ message = null }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: { noInformationFound }
  } = localizedStrings;

  const displayMessage = message || noInformationFound;

  return (
    <NoInfoContainer>
      <Icon icon={Information} variant={{ size: 'large' }} accessibilityLabel="No information" />
      <div style={{ marginTop: '1rem' }}>
        <Typography variant={{ bold: true }}>{displayMessage}</Typography>
      </div>
    </NoInfoContainer>
  );
};

export default NoInformationFound;